'use strict';
const config = require("@zerolight/cloudmine-api-client").config;

// Expose in window too, for hacks and giggles
window.PanelConfiguration = config;
module.exports = config;